<!-- =========================================================================================
    File Name: ForgotPassword.vue
    Description: FOrgot Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img">
    <div
      class="
        vx-col
        w-4/5
        sm:w-4/5
        md:w-3/5
        lg:w-3/4
        xl:w-3/5
        mx-auto
        self-center
      "
    >
      <vx-card id="forgot-password-loading" class="vs-con-loading__container">
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div
              class="
                vx-col
                hidden
                sm:hidden
                md:hidden
                lg:block
                lg:w-1/2
                mx-auto
                self-center
              "
            >
              <img
                src="@/assets/images/pages/forgot-password.png"
                alt="login"
                class="mx-auto"
              />
            </div>
            <div
              class="
                vx-col
                sm:w-full
                md:w-full
                lg:w-1/2
                mx-auto
                self-center
                d-theme-dark-bg
              "
            >
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">Recover your password</h4>
                  <p>
                    Please enter your email address and we'll send you
                    instructions on how to reset your password.
                  </p>
                </div>

                <vs-row>
                  <vs-col vs-w="12">
                    <vs-input
                      type="email"
                      label-placeholder="Email"
                      v-model="email"
                      name="email"
                      class="w-full"
                      @keyup.enter="submit"
                      v-validate="'email|required'"
                    />
                  </vs-col>
                  <vs-col vs-w="12" class="mt-2">
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('email')"
                    >
                      {{ errors.first('email') }}
                    </span>
                  </vs-col>
                  <vs-col vs-w="12" class="mt-2">
                    <vs-alert
                      :active="alert"
                      color="success"
                      icon="new_releases"
                      class="mb-6"
                    >
                      <span>Email Sent.</span>
                    </vs-alert>
                  </vs-col>
                  <vs-col vs-w="12" class="mt-4">
                    <vs-button
                      type="border"
                      to="/login"
                      class="px-4 w-full md:w-auto"
                      >Back To Login</vs-button
                    >
                    <vs-button
                      class="
                        float-right
                        px-4
                        w-full
                        md:w-auto
                        mt-3
                        mb-8
                        md:mt-0
                        md:mb-0
                      "
                      @click="submit"
                      :disabled="disabledSubmit"
                      >Recover Password</vs-button
                    >
                  </vs-col>
                </vs-row>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import user from '@/http/requests/user'
export default {
  computed: {
    disabledSubmit() {
      return this.errors.any() || this.email === ''
    },
  },
  data() {
    return {
      alert: false,
      email: '',
    }
  },
  methods: {
    submit() {
      this.openLoading()
      user
        .forgotPassword({ email: this.email })
        .then((res) => {
          this.alert = true
          this.closeLoading()
        })
        .catch((res) => {
          this.showValidationErrors(res)
          this.closeLoading()
        })
    },
    openLoading() {
      this.$vs.loading({
        container: '#forgot-password-loading',
        scale: 0.45,
      })
    },
    closeLoading() {
      this.$vs.loading.close('#forgot-password-loading > .con-vs-loading')
    },
  },
}
</script>
